import { type ReactElement, type Ref } from 'react';
import classnames from 'classnames';

interface MenuButtonProps {
  active: boolean;
  className?: string;
  icon?: ReactElement | null;
  onClick?: (() => void) | null;
  ref?: Ref<HTMLButtonElement>;
  testId?: string;
  text?: string;
}

const MenuButton = ({ active, testId, text, className = '', onClick = null, icon = null, ref }: MenuButtonProps) => (
  <button
    className={classnames('btn btn-link btn-link__inline menu-button', className, {
      'menu-button--active': active,
    })}
    data-testid={testId}
    onClick={onClick as (() => void) | undefined}
    ref={ref}
    type="button"
  >
    <div className="menu-button__icon">{icon}</div>
    <span className="menu-button__label">{text}</span>
  </button>
);

export default MenuButton;
